import React, { useState } from 'react'
import { Wrapper, FormContainer } from './style'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { UpdateProfileDto } from 'src/services/types'
import { useDispatch } from 'react-redux'
import { updateProfileAction } from 'src/redux/actions/profileAction'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { RiErrorWarningLine } from 'react-icons/ri'
import useUserData from 'src/hooks/useUserData'
import useSnackbar from 'src/hooks/useSnackBar'

const BaseProfileSetings = () => {
  const USER_DATA = useUserData()
  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState<UpdateProfileDto>({
    first_name: USER_DATA.user.first_name,
    last_name: USER_DATA.user.last_name,
    phone_number: USER_DATA.user.phone_number,
    email: USER_DATA.user.email,
  })

  const dispatch = useDispatch()
  const { first_name, last_name, email, phone_number } = userData
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    const payload = {
      profileSettings: {
        ...userData,
      },
    }
    console.log(payload)
    if (
      !first_name ||
      !last_name ||
      first_name.length <= 2 ||
      last_name.length <= 2
    ) {
      setSubmitted(true)
      return
    }
    setLoading(true)
    dispatch(updateProfileAction({ payload, onSuccess, onError }))
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error updating Profile data',
      severity: 'error',
    })
  }
  const disabled = true
  const Disabled = () => {
    if (
      !first_name ||
      !last_name ||
      first_name.length <= 2 ||
      last_name.length <= 2
    ) {
      return 'blur'
    }
    return null
  }
  return (
    <FormContainer>
      <Wrapper onSubmit={handleSubmit}>
        <ModalTitleText>Profile Details</ModalTitleText>
        <div className="amount">
          <LabelText>First Name</LabelText>
          <div
            className={
              'form-group' + (submitted && !first_name ? ' has-error' : '')
            }
          >
            <QuicksaveInput
              type="text"
              placeholder="Full name"
              name="first_name"
              value={first_name}
              onChange={handleChange}
            />
            {(submitted && !first_name && (
              <p className="error-text">First Name is required</p>
            )) ||
              (submitted && first_name.length <= 2 && (
                <p className="error-text">First Name is too short</p>
              ))}
            <RiErrorWarningLine className="error-icon" />
          </div>
        </div>
        <div className="amount">
          <LabelText>Last Name</LabelText>
          <div
            className={
              'form-group' + (submitted && !last_name ? ' has-error' : '')
            }
          >
            <QuicksaveInput
              type="text"
              placeholder="last_name"
              name="last_name"
              value={last_name}
              onChange={handleChange}
            />
            {(submitted && !last_name && (
              <p className="error-text">Last Name is required</p>
            )) ||
              (submitted && last_name.length <= 2 && (
                <p className="error-text">Last Name is too short</p>
              ))}
            <RiErrorWarningLine className="error-icon" />
          </div>
        </div>
        <div className="amount">
          <LabelText>Email Address</LabelText>
          <div className="form-group">
            <QuicksaveInput
              className="height"
              type="email"
              name="email"
              value={email}
              placeholder=""
              disabled={disabled}
            />
          </div>
        </div>
        <div className="amount">
          <LabelText>Phone Number</LabelText>
          <div className="form-group">
            <QuicksaveInput
              className="height"
              type="number"
              name="phone_number"
              value={phone_number}
              placeholder="e.g 3,000"
              disabled={disabled}
            />
          </div>
        </div>
        <div className="tops">
          <ModalButton className={`confirm ${Disabled()}`}>
            Update Profile {loading && <Spinner />}
          </ModalButton>
        </div>
      </Wrapper>
    </FormContainer>
  )
}
export { BaseProfileSetings }
